export default "__VITE_ASSET__2d19a4be__"